export default "__VITE_ASSET__DCOp1ulV__"